import Phaser from 'phaser';

export default class FailScene extends Phaser.Scene {
    constructor() {
        super({ key: 'FailScene' });
    }

    create(): void {
        const { width, height } = this.scale;
        
        this.add.text(width / 2, height / 2, 'FAIL', {
            fontSize: '48px',
            color: '#fff'
        }).setOrigin(0.5);
    }
} 